<template>
  <div class="form-check form-check-custom form-check-solid">
    <input
        type="checkbox"
        class="form-check-input"
        :class="{ 'is-invalid': form.errors.has(name) }"
        :id="name"
        :checked="value"
        @change="emitValue($event.target.checked)"
    />
    <label class="form-check-label" :for="name"
    >{{ label }}</label
    >
    <div>
      <has-error :form="form" :field="name"></has-error>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String|Number,
      default: '',
      required: false,
    },
    name: {
      type: String|Number,
      required: true,
    },
    label: {
      type: String|Number,
      required: true,
    },
    form: {
      type: Object,
      required: true
    }
  },
  methods: {
    emitValue(value){
      this.$emit('input', value)
    }
  },
}
</script>